import { createApp } from "vue";
import CatalogPrices from "./CatalogPrices.vue";

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector("#catalogPrices")) {
    return
  }

  const catalogPrices = createApp({
    components: {CatalogPrices }
  })

  catalogPrices.mount("#catalogPrices")
})
